import React from 'react';
import { Card, Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'var(--bg-primary)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Card 
        style={{ 
          maxWidth: '500px', 
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          borderRadius: '12px',
          border: '1px solid var(--border-primary)'
        }}
      >
        <div style={{ padding: '40px 20px' }}>
          <Title level={1} style={{ 
            color: 'var(--text-primary)', 
            marginBottom: '16px', 
            fontSize: '80px',
            fontWeight: 'bold',
            lineHeight: 1,
            margin: 0
          }}>
            404
          </Title>
          
          <Title level={2} style={{ 
            color: 'var(--text-primary)', 
            marginBottom: '24px', 
            fontSize: '24px',
            fontWeight: 'normal',
            margin: 0
          }}>
            Page Not Found
          </Title>
          
          <div style={{ marginBottom: '32px' }}>
            <Text style={{ 
              fontSize: '16px', 
              color: 'var(--text-secondary)',
              lineHeight: 1.6
            }}>
              The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </Text>
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '12px', 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Button
              type="primary"
              size="large"
              onClick={handleGoHome}
              style={{
                height: '40px',
                padding: '0 24px'
              }}
            >
              Go Home
            </Button>
            
            <Button
              size="large"
              onClick={handleGoBack}
              style={{
                height: '40px',
                padding: '0 24px'
              }}
            >
              Go Back
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default NotFound;
